export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_LIFE_STAGE_MAPPING';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_LIFE_STAGE_MAPPING';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_LIFE_STAGE_MAPPING';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
